import { appbarHeight } from "themes/constants/sizes"
import { theme } from "themes/default/theme"
const drawerWidth = 340

export const styles = {
  drawer: (theme) => ({
    width: drawerWidth,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: drawerWidth,
      boxSizing: "border-box",
      backgroundColor: theme.palette.primary.blue,
      color: "white",
      top: `${appbarHeight}px`,
      left: 5,
      height: `calc(100vh - ${appbarHeight + 10}px)`,
      mt: 0.625,
      borderRadius: "2rem",
      p: "2rem 1.5rem",
    },
  }),
  sidebarContent: {
    flex: 1,
    height: "100%",
  },
  titleContent: {
    "& span": {
      fontFamily: "'Poppins light',Poppins",
    },
  },
  menuContent: {
    flexGrow: 1,
    overflow: "auto",
    direction: "rtl",
    mt: "1rem",
  },
  accountContent: {
    boxShadow: "0 1px 1px #00000029",
    backgroundColor: theme.palette.common.white,
    borderRadius: "3rem",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    overflow: "hidden",
    py: 1.6875,
    px: 0.875,
    border: `1px solid ${theme.palette.border.primary}`,
  },
  menuItem: (theme) => ({
    p: ".5rem 0 .5rem 1rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.blue,
      "&:before": {
        content: '""',
        position: "absolute",
        backgroundColor: theme.palette.primary.main,
        width: "5px",
        height: "100%",
        left: 0,
        top: 0,
        borderRadius: "0 10px 10px 0",
      },
    },
  }),
  activeMenuItem: (theme) => ({
    backgroundColor: theme.palette.primary.blue,
    "&:before": {
      content: '""',
      position: "absolute",
      backgroundColor: theme.palette.primary.main,
      width: "5px",
      height: "100%",
      left: 0,
      top: 0,
      borderRadius: "0 10px 10px 0",
    },
  }),
  activeMenuIcon: (theme) => ({
    color: theme.palette.primary.main,
  }),
  menuIcon: (theme) => ({
    color: theme.palette.common.white,
    fontSize: 20,
    minWidth: 25,
    mr: "1rem",
    "& svg": {
      width: 21,
      height: 21,
    },
  }),
  menuItemText: (theme) => ({
    color: theme.palette.common.white,
    m: 0,
    fontSize: 14,
  }),
  menuList: {
    p: 0,
  },
  lastMenuItem: {
    mb: "1rem",
  },
  accountDescription: {
    flex: 1,
    mx: 0.875,
    height: 42,
    justifyContent: "space-between",
    "& span": {
      color: "black",
    },
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  logoutIcon: {
    fontSize: 16,
    color: "black",
  },
  userAvatar: {
    width: 42,
    height: 42,
  },
  accountName: {
    fontSize: 14,
    fontWeight: "600",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  accountUsername: {
    fontSize: 11,
    fontWeight: "normal",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  badge: (theme) => ({
    bgcolor: theme.palette.primary.main,
    color: theme.palette.common.white,
    px: 1,
    borderRadius: "12px",
    fontSize: "0.75rem",
  }),
  tutorialSwitch: {
    "& .Mui-checked+.MuiSwitch-track": {
      backgroundColor: "#fde2d2",
      opacity: 1,
    },
    "& .Mui-checked .MuiSwitch-thumb": {
      color: theme.palette.primary.main,
      border: "1px solid #fff",
    },
    "& .MuiSwitch-track": {
      backgroundColor: "#eee",
      opacity: 1,
    },
    "& .MuiSwitch-thumb": {
      color: "#b8b8b8",
      border: "1px solid #fff",
    },
  },
}
